import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import type { Notification } from '../types/notification.types';

interface ResponseDialogProps {
  notification: Notification;
  isOpen: boolean;
  observation: string;
  isUpdating: boolean;
  onObservationChange: (value: string) => void;
  onClose: () => void;
  onSubmit: (notification: Notification) => void;
}

export const ResponseDialog: React.FC<ResponseDialogProps> = ({
  notification,
  isOpen,
  observation,
  isUpdating,
  onObservationChange,
  onClose,
  onSubmit,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Responder Notificación</DialogTitle>
        </DialogHeader>
        <Textarea
          value={observation}
          onChange={(e) => onObservationChange(e.target.value)}
          placeholder="Ingrese comentario aquí..."
          className="mb-4"
        />
        <DialogFooter>
          <Button
            onClick={() => onSubmit(notification)}
            disabled={isUpdating || !observation.trim()}
          >
            {isUpdating ? "Actualizando..." : "Resolver"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 